<template>
    <div
        v-if="visible"
        class="common-loading"
        @touchmove.prevent>
        <div class="loading-con">
            <van-loading color="#fff" />
            <div class="loading-text">加载中...</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading',
    props: ['visible'],
}
</script>

<style lang="scss" scoped>
.common-loading{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .loading-con{
        width: 160px;
        height: 100px;
        border-radius: 4px;
        background: rgba(0, 0, 0, .6);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .loading-text{
            margin-top: 10px;
            color: #fff;
        }
    }
}
</style>